"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAny = updateAny;
exports.createAny = createAny;
exports.deleteAny = deleteAny;
exports.getAny = getAny;
const http_1 = require("../http");
async function updateAny(path, content) {
    const response = await (0, http_1.fetchWithError)(`/api/v1/${path}`, {
        method: 'PUT',
        body: content instanceof FormData ? content : JSON.stringify(content),
        headers: content instanceof FormData
            ? {}
            : {
                'Content-Type': 'application/json',
            },
    });
    await response.text();
}
async function createAny(path, content) {
    const response = await (0, http_1.fetchWithError)(`/api/v1/${path}`, {
        method: 'POST',
        body: content instanceof FormData ? content : JSON.stringify(content),
        headers: content instanceof FormData
            ? {}
            : {
                'Content-Type': 'application/json',
            },
    });
    await response.text();
}
async function deleteAny(path) {
    const response = await (0, http_1.fetchWithError)(`/api/v1/${path}`, { method: 'DELETE' });
    await response.text();
}
async function getAny(path) {
    const response = await (0, http_1.fetchWithError)(`/api/v1/${path}`, { method: 'GET' });
    return await response.json();
}
